import axios from 'axios';

export default {
    async getNotifications(params){
        return axios.get(`/api/enduser/notifications`, { params });
    },
    async getUnreadNotification(){
        return axios.get(`/api/enduser/notifications/unread`);
    },
    async seenNotification(data){
        return axios.post(`/api/enduser/notification/seen`, data);
    }
}